// extracted by css-extract-rspack-plugin
export default {"Heading":"use-tree-pane-module__Heading__OiAv1P0"};